import { useState } from 'react';
import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
// import { getReceipt } from '../../services/stripe';
import headerImg from './../../images/others/header.jpg';
import matwLogo from './../../images/general/MATW-Logo.png';
import footerImgFr from './../../images/general/receipt-footer-banner.png';
// import footerImg from './../../images/others/MATW_DontJustWatch_2025_WebBanner_1920x384.jpg';
import footerImg from './../../images/others/MATW_Palestine_2025_WeDontAskWeDeliver_ReceiptBanner.jpg';
// import footerImg from './../../images/others/MATW_Qurban_2025_FooterBanner_Phase.jpg';
// import footerQurbaniImg from './../../images/others/MATW_Qurbani_2025_FooterBanner_Phase.jpg';
import thanksImg from './../../images/others/thankyou.png';
import services from '../../services';
import Moment from 'moment';
import ShowCurrencies from '../../utils/showCurrencies';
import AddUniversalUSAScript from '../../utils/addUniversalUSAScript';
import androidAppLogo from './../../images/others/GetItOnGooglePlay_Badge_Web_color_English.png';
import iosAppLogo from './../../images/others/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import androidAppQr from './../../images/others/qr-code-android.svg';
import appleAppQr from './../../images/others/qr-code-apple.svg';
// import { checkDomain } from '../../utils/checkDomain';
// import CopyToClipboard from '../../utils/copyToClipboard';

const ReceiptPage = () => {
  const [params] = useSearchParams();
  const ID = params.get('session_id') || params.get('id');
  const PAYPAL_ID = params.get('id');
  const Transaction_ID = params.get('transaction_id');
  const GATEWAY = params.get('gateway');
  const MODE = params.get('mode');
  const PayPalTokenID = params.get('token') || params.get('session_id') || params.get('id');
  const PayPalSubscriptionID = params.get('subscription_id') || params.get('session_id') || params.get('id');
  const [isUk, setIsUk] = useState(false);
  const [isUsa, setIsUsa] = useState(false);
  const [isFr, setIsFr] = useState(false);
  const [isAus, setIsAus] = useState(false);
  const [checkoutData, setCheckoutData] = useState(null);
  const FlexibleID = params.get('flexible_id');
  const [allProducts, setAllProducts] = useState([]);
  const SUPPORTED_LANGUAGES = ['fr', 'de', 'en', 'ar', 'es', 'nl'];
  const LANGUAGE = (() => {
    if (params.get('lang')) {
      const lang = params.get('lang') || '';
      return SUPPORTED_LANGUAGES.includes(lang) ? lang : 'en';
    } else {
      return '';
    }
  })();

  const handleCryptoOrder = async order_id => {
    // let tempRequest = Transaction_ID ? `id=${PAYPAL_ID}&transaction_id=${Transaction_ID}` : `id=${PAYPAL_ID}`
    let tempRequest = Transaction_ID ? `id=${order_id}&transaction_id=${Transaction_ID}` : `id=${order_id}`;
    try {
      const response = await services.getCryptoReceipt(tempRequest);
      console.log('response get CryptoOrder', response);
      setIsUk(true);
      let _crypto_total_paid = 0;
      response?.data.crypto_transactions?.map(i => (_crypto_total_paid = _crypto_total_paid + Number(i.crypto_currency_total_amount_paid)));
      let model = {
        name: response?.data.user?.name,
        email: response?.data.user?.email,
        donorID: response?.data.user?.id,
        gateway: 'Crypto',
        donationDate: response?.data.created_at,
        address: '',
        donationID: response?.data.reference_id,
        paymentMethod: 'Crypto',
        onBehalf: response?.data?.plaque_name,
        currency: response?.data.fiat_currency,
        total_paid_donations: response?.data.crypto_currency_total_amount_paid,
        donationTable: response?.data.crypto_order_products?.map(i => ({
          type: i.product ? i.product.name : '',
          project: i.product ? i.product.name : '',
          // QTY: Number(i.unit_price) === 1 ? 1 : i.quantity,
          QTY: i.quantity,
          // amount: (i.product && i.product.name === 'Admin Contribution') && response?.data.fiat_currency === 'EUR' ? 2.50 : Number(i.unit_price) === 1 ? i.quantity : i.unit_price,
          amount: i.product && i.product.name === 'Admin Contribution' && response?.data.fiat_currency === 'EUR' ? 2.5 : i.unit_price,
          currency: response?.data.fiat_currency,
          mode: 'Payment',
          frequency: 'one-off',
          plaque_name: i.plaque_name ? i.plaque_name : 'For the sake of Allah SWT',
        })),
        crypto_total_paid: _crypto_total_paid,
        cryptoTable: response?.data.crypto_transactions?.map(i => ({
          type: i.type ? i.type : '',
          transaction_id: i.transaction_id ? i.transaction_id : '',
          crypto_currency: i.crypto_currency ? i.crypto_currency : '',
          total_crypto_amount: i.total_crypto_amount ? i.total_crypto_amount : '',
          crypto_currency_total_amount_paid: i.crypto_currency_total_amount_paid ? Number(i.crypto_currency_total_amount_paid) : 0,
          date: i.created_at ? i.created_at : '',
        })),
        totalPrice: Number(response?.data.fiat_currency_total_amount),
      };
      if (response?.data.crypto_order_products && response?.data.crypto_order_products[0] && response?.data.crypto_order_products[0].value === 1) {
        model.donationTable[0].amount = response?.data.crypto_order_products[0].quantity;
        model.donationTable[0].QTY = response?.data.crypto_order_products[0].value;
      }
      console.log('before set crypto=', model);
      setCheckoutData(model);
    } catch (error) {
      console.error('error========', error);
    }
  };
  /* ------------------------------ Start methods ----------------------------- */
  const handleRecurring = value => {
    switch (value) {
      case 'day':
        return 'Daily';
      case 'DAY':
        return 'Daily';
      case 'month':
        return 'Monthly';
      case 'week':
        return 'Weekly';
      case 'year':
        return 'Yearly';
      case 'one-off':
        return 'Single';
      default:
        return '';
    }
  };
  const handleFirstCharCapital = text => {
    if (text && text !== '') {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
  };

  const handleDailyRamadan = async order_id => {
    try {
      const response = await services.getFlexibleStripeReceipt(order_id);
      console.log('response of daily=', response);
      const Data = response.data;
      let model = {
        name: Data?.user?.name,
        email: Data?.user?.email,
        donorID: Data?.user?.id,
        gateway: 'Card',
        donationDate: Data?.gateway_data?.schedule_created_at,
        address: '',
        donationID: Data?.id,
        paymentMethod: 'Card',
        currency: Data?.currency,
        onBehalf: Data?.plaque_name,
        donationTable: Data?.gateway_data?.donation_schedule?.map(i => ({
          date: i.date,
          products: i.products,
          // type: i.stripe_price_point.product.category ? i.stripe_price_point.product.category.name : '',
          // project: i.stripe_price_point.product.name,
          type: '',
          currency: Data?.currency,
          mode: 'Scheduled',
          plaque_name: 'For the sake of Allah SWT',
          frequency: 'Single',
          status: Data?.gateway_data.processed_dates.length
            ? Data?.gateway_data.processed_dates.map(process => {
                if (process === i.date) {
                  return 'Paid';
                } else {
                  return 'Pending';
                }
              })
            : 'Pending',
        })),
        totalPrice: Data.gateway_data ? Data.gateway_data.total_scheduled_amount : 0,
        recurring: Data.gateway_data.feature === 'dhul-hijjah' ? 'Daily' : 'Weekly (Friday)',
        feature: Data.gateway_data.feature || '',
      };
      if (Data?.stripe_account.toLowerCase() === 'au') {
        setIsUk(false);
        setIsUsa(false);
      } else if (Data?.stripe_account.toLowerCase() === 'us') {
        setIsUk(false);
        setIsUsa(true);
      } else {
        setIsUk(true);
        setIsUsa(false);
      }
      console.log('before set Flexible=', model);
      setCheckoutData(model);
    } catch (error) {
      console.log('error=', error);
    }
  };
  const getAllProducts = async () => {
    let tempPrds = [];
    try {
      const response = await services.allProducts();
      response.data.map(item => {
        item.sub_categories.map(inner_item => {
          inner_item.products.map(inner_item_product => {
            if (Number(inner_item_product.status) === 1) {
              tempPrds.push(inner_item_product);
            }
            return inner_item_product;
          });
          return inner_item;
        });
        return item;
      });
      setAllProducts(tempPrds);
    } catch (error) {
      console.error('error========', error);
    }
  };
  const getProductName = creator => {
    let name = '';
    allProducts.length &&
      allProducts.map(item => {
        if (item.creator === creator) {
          name = item.name;
        }
        return item;
      });
    return name;
  };
  const handleTotalAmount = prds => {
    let total = 0;
    prds.map(item => {
      total += item.amount;
      return item;
    });
    return total;
  };
  const handleOrder = async (id, gateway) => {
    let tempRequest = Transaction_ID ? `id=${id}&transaction_id=${Transaction_ID}` : `id=${id}`;
    try {
      const response = await services.handleAllOrders(tempRequest);
      console.log('response success', response, gateway);
      setIsUk(false);
      let data = response?.data.session;
      const stripeAccount = data?.stripe_account?.toLowerCase() || 'uk';
      setIsAus(stripeAccount === 'au');
      setIsUsa(stripeAccount === 'us');
      setIsFr(stripeAccount === 'fr');
      setIsUk(!['au', 'us', 'fr'].includes(stripeAccount));
      let model = {
        name: data.user?.name,
        email: data.user?.email,
        donorID: data.user?.id,
        gateway: gateway,
        donationDate: data.created_at,
        address: '',
        donationID: data.id,
        paymentMethod: gateway,
        onBehalf: data?.plaque_name,
        currency: data.currency,
        donationTable: data.checkout_session_products?.map(i => ({
          type: i.name || '',
          project: i.product.name || '',
          QTY: Number(i.amount) === 1 ? 1 : i.quantity,
          amount:
            i && i.name === 'Admin Contribution' && data.currency.toUpperCase() === 'EUR' ? 2.5 : Number(i.amount) === 1 ? i.quantity : i.amount,
          currency: data.currency,
          mode: gateway === 'flexible' ? 'Scheduled' : MODE ? MODE : data.mode,
          frequency: MODE === 'subscription' || data.mode === 'subscription' ? data.recurring : 'one-off',
          plaque_name: i.plaque_name ? i.plaque_name : 'For the sake of Allah SWT',
        })),
        totalPrice: data.amount_total,
        recurring: data.recurring,
      };
      if (data.checkout_session_products[0] && data.checkout_session_products[0].amount === 1) {
        model.donationTable[0].amount = data.checkout_session_products[0].quantity;
        model.donationTable[0].QTY = data.checkout_session_products[0].amount;
      }
      console.log('before set paypal=', model);
      setCheckoutData(model);
    } catch (error) {
      console.error('error========', error);
    }
  };
  /* -------------------------------------------------------------------------- */
  /* ------------------------------- Start hooks ------------------------------ */

  useEffect(() => {
    console.log('GATEWAY', GATEWAY, ID, PayPalTokenID);
    if (GATEWAY === 'paypal') {
      handleOrder(MODE === 'subscription' ? PayPalSubscriptionID : PayPalTokenID, GATEWAY);
    } else if (GATEWAY === 'stripe') {
      if (MODE === 'flexible') {
        handleDailyRamadan(FlexibleID);
        // handleOrder(FlexibleID, 'flexible')
      }
      handleOrder(ID, 'stripe');
    } else if (GATEWAY === 'crypto') {
      handleCryptoOrder(PAYPAL_ID);
    } else if (GATEWAY === 'chargebee') {
      handleOrder(ID, 'Adyen');
    } else if (GATEWAY === 'adyen') {
      handleOrder(ID, 'Adyen');
    } else {
      handleOrder(ID, 'Stripe');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [GATEWAY]);
  useEffect(() => {
    if (!LANGUAGE) return; // No change if no lang param
    const url = new URL(window.location.href);
    const pathnameParts = url.pathname.split('/').filter(Boolean);

    // Always replace the first segment if it's a language
    if (SUPPORTED_LANGUAGES.includes(pathnameParts[0])) {
      pathnameParts[0] = LANGUAGE;
    } else {
      pathnameParts.unshift(LANGUAGE);
    }
    // Remove 'en' from path for default if you want
    let newPathname = LANGUAGE === 'en' ? `/${pathnameParts.slice(1).join('/')}` : `/${pathnameParts.join('/')}`;
    const newUrl = `${url.origin}${newPathname}${url.search}`;
    if (newUrl !== window.location.href) {
      window.location.href = newUrl;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LANGUAGE]);

  useEffect(() => {
    getAllProducts();
    // window.scroll({top: 0, left: 0, behavior: 'smooth' })
    window.scroll(0, 0);
    AddUniversalUSAScript();
  }, []);
  /* --------------- ----------------------------------------------------------- */
  return checkoutData ? (
    <div className="lg:container mx-auto lg:max-w-8xl bg-white">
      {isFr ? (
        <div className="lg:container mx-auto lg:max-w-4xl bg-white">
          {/* Header with MATW Logo */}
          <div className="flex justify-start p-6">
            <img src={matwLogo} alt="MATW Project" className="w-32" />
          </div>

          {/* Receipt Title */}
          <div className="text-center font-bold text-2xl mb-6">RECU FISCAL POUR DON</div>

          {/* Organization Information */}
          <div className="px-8 mb-6">
            <div className="mb-4">Article 200 du Code Général des Impôts</div>
            <div className="font-bold">MATW INTERNATIONAL FRANCE</div>
            <div>Numéro RNA : W751273564</div>
            <div>43 rue de Liege</div>
            <div>75008 Paris 8e</div>
            <div className="mt-2">Oeuvre ou organisme d'intérêt général</div>
            <div>Humanitaire - Caritative</div>
            <div>
              Objet : l'association a pour objectif de maintenir et d'exploiter de manière permanente et active une organisation de secours publique à
              but non lucratif
            </div>
          </div>

          {/* Receipt Number */}
          <div className="px-8 mb-6">
            <div className="font-bold">N° d'ordre de reçu : {checkoutData?.donationID || '02032025-HA-ASSO-000081'}</div>
          </div>

          {/* Donor Information */}
          <div className="px-8 mb-6">
            <div className="font-bold">Donateur :</div>
            <div>Numéro de donateur : {checkoutData?.donorID}</div>
            <div className="uppercase">{checkoutData?.name}</div>
            <div>{checkoutData?.address?.line1}</div>
            {checkoutData?.address?.line2 && <div>{checkoutData.address.line2}</div>}
            <div>
              {checkoutData?.address?.postalCode} {checkoutData?.address?.city}
            </div>
          </div>

          {/* Beneficiary Information */}
          <div className="px-8 mb-6">
            <div className="font-bold">Bénéficiaire :</div>
            <div>
              MATW INTERNATIONAL FRANCE reconnaît avoir reçu, au titre des versements ouvrant droit à une réduction d'impôt, la somme de : ***{' '}
              {checkoutData?.totalPrice} {checkoutData?.currency || 'Euros'} ***
            </div>
            {MODE === 'flexible' && (
              <div className="flex items-center col-span-12 sm:col-span-3 text-sm sm:text-md md:text-base gap-1">
                <span className="">Recurring:</span>
                <span className="text-stone-200 text-sm md:text-base">{checkoutData.recurring}</span>
              </div>
            )}
          </div>

          {/* Donation Details */}
          <div className="px-8 mb-8">
            <div>Date du don {Moment(checkoutData?.donationDate).format('DD/MM/YYYY, HH:mm:ss')}</div>
            <div>Forme du don : Don manuel</div>
            <div>Nature du don : Numéraire</div>
            <div>Mode de versement : {checkoutData?.paymentMethod || 'Carte bancaire'}</div>
          </div>

          {/* Certification */}
          <div className="px-8 text-sm mb-6">
            <p className="font-bold">
              Le bénéficiaire certifie sur l'honneur que les dons et versements qu'il reçoit ouvrent droit à la réduction d'impôt prévue à l'article
              200 du Code Général des Impôts.
            </p>
            <p>
              Particulier : vous pouvez bénéficier d'une réduction d'impôt égale à 66 % du montant de votre don, dans la limite de 20 % de votre
              revenu imposable.
            </p>
          </div>

          <div className="">
            <img src={footerImgFr} alt="MATW" className="w-full" />
          </div>
        </div>
      ) : (
        <>
          <div className="h-auto">
            <img src={headerImg} alt="MATW" />
          </div>
          {/* {console.log("checkout=",checkoutData)} */}
          <div className="text-white py-3 px-2 pr-2 pl-2 bg-[#f60362] grid grid-cols-10 gap-0 md:gap-4">
            <div className="flex items-center lg:flex-col col-span-10 lg:col-span-2 text-sm sm:text-md md:text-base gap-1">
              <span className="min-w-[112px]">Donor:</span>
              <span className="text-stone-200">{checkoutData.name}</span>
            </div>
            <div className="col-span-10 lg:col-span-8 flex">
              <div className="grid grid-cols-12 w-full">
                <div className="flex items-center col-span-12 sm:col-span-3 text-sm sm:text-md md:text-base gap-1">
                  <span className="min-w-[112px]">Donor ID:</span>
                  <span className="text-stone-200 text-sm md:text-base">{checkoutData.donorID}</span>
                </div>
                <div className="flex items-center col-span-12 md:col-span-4 text-sm sm:text-md md:text-base gap-1">
                  {GATEWAY !== 'crypto' && (
                    <>
                      <span className="min-w-[112px]">Transaction ID:</span>
                      <span className="text-stone-200 text-sm md:text-base">{checkoutData.donationID}</span>
                    </>
                  )}
                </div>
                <div className="flex items-center col-span-12 md:col-span-3 text-sm sm:text-md md:text-base gap-1">
                  <span className="min-w-[112px]">Payment Method:</span>
                  <span className="text-stone-200 text-sm md:text-base">{checkoutData.paymentMethod}</span>
                </div>
                <div className="flex items-center col-span-12 sm:col-span-4 lg:col-span-6 text-sm sm:text-md md:text-base gap-1">
                  <span className="min-w-[112px]">Email:</span>
                  <span className="text-stone-200 text-sm md:text-base">{checkoutData.email}</span>
                </div>
                {/* <div className="flex items-center col-span-12 sm:col-span-6 lg:col-span-6 text-sm sm:text-md md:text-base gap-1">
                  <span className="">On Behalf of:</span>
                  <span className="text-stone-200 text-sm md:text-base">{checkoutData.onBehalf}</span>
                </div> */}
              </div>
            </div>
          </div>
          <div className="px-4 md:mt-8 lg:px-12 mt-4">
            <div
              className={`border-x-0 border-b-2 border-black my-2 text-center hidden md:grid py-2 font-bold ${
                MODE === 'flexible' ? 'md:grid-cols-8' : 'md:grid-cols-9'
              } grid-gap-4`}
            >
              <div className="text-left hidden">DONATION TYPE</div>
              {MODE === 'flexible' && <div className="text-left col-span-1">Date</div>}
              <div className="col-span-2 uppercase">Project</div>
              {MODE !== 'flexible' && <div className="col-span-1 uppercase">mode</div>}
              {MODE !== 'flexible' && <div className="col-span-1 uppercase">status</div>}
              <div className="col-span-2 uppercase">On behalf of</div>
              <div className="col-span-1">QTY</div>
              <div className="col-span-1 text-right">ITEM AMOUNT</div>
              <div className="col-span-1 text-right">TOTAL AMOUNT</div>
            </div>
            <div className="my-3 text-center md:grid py-2 md:grid-cols-8 grid-gap-4 border-b border-stone-400 mb-5">
              {checkoutData.donationTable?.map((i, index) => {
                if (MODE === 'flexible') {
                  return (
                    <div
                      className={`w-full col-span-8 md:grid md:grid-cols-8 grid-gap-4 py-1 ${
                        index === checkoutData.donationTable.length - 1 ? '' : 'md:border-b md:border-stone-200'
                      }`}
                      key={`checkout_flexible${index}`}
                    >
                      <div className="col-span-1 flex text-left items-center">
                        <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Date:</div>
                        <div className="md:text-center text-sm">{Moment(i.date).format('LL')}</div>
                      </div>
                      <div className="col-span-6 md:grid md:grid-cols-6 grid-gap-4">
                        {i.products.map((prd, index) => {
                          return (
                            <div
                              key={`flexibles${index}`}
                              className="col-span-6 md:grid md:grid-cols-6 md:grid-gap-4 border-b border-stone-200 md:border-none"
                            >
                              <div className="col-span-2 flex text-left md:justify-center items-center">
                                <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Project:</div>
                                <div className="whiteTitle text-sm">{getProductName(prd.product_id)}</div>
                              </div>
                              {/* <div className="col-span-1 flex text-left md:justify-center items-center">
                              <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Mode:</div>
                              <div className="whiteTitle text-sm">{handleFirstCharCapital(i.mode)}</div>
                            </div>
                            <div className="col-span-1 flex text-left md:justify-center items-center">
                              <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Status:</div>
                              <div className="whiteTitle text-sm">{i.status}</div>
                            </div> */}
                              <div className="col-span-2 flex text-left md:justify-center items-center">
                                <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">On Behalf Of:</div>
                                <div className="md:text-center text-sm">{prd.plaque_name}</div>
                              </div>
                              <div className="col-span-1 flex text-left md:justify-center items-center">
                                <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">QTY:</div>
                                {prd.amount}
                              </div>
                              <div className="col-span-1 price flex text-left md:justify-end items-center text-[#f60362]">
                                <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Item Amount:</div>
                                {ShowCurrencies(i.currency, prd.amount)}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="col-span-1 price flex text-left md:justify-end items-center text-[#f60362]">
                        <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Total Amount:</div>
                        {ShowCurrencies(i.currency, handleTotalAmount(i.products))}
                      </div>
                    </div>
                  );
                } else if (i.QTY && i.amount) {
                  return (
                    <div
                      className={`w-full col-span-8 md:grid md:grid-cols-9 grid-gap-4 ${
                        index === checkoutData.donationTable.length - 1 ? '' : 'border-b border-stone-200'
                      }`}
                      key={`checkout${index}`}
                    >
                      {/* <div className="flex- hidden text-left md:justify-start items-center">
                    <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Donation Type:</div>
                    {i.type}
                  </div> */}
                      <div className="col-span-2 flex text-left md:justify-center items-center">
                        <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Project:</div>
                        <div className="md:text-center">{i.project}</div>
                      </div>
                      <div className="col-span-1 flex text-left md:justify-center items-center">
                        <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Mode:</div>
                        <div className="whiteTitle">{handleFirstCharCapital(i.mode)}</div>
                      </div>
                      <div className="col-span-1 flex text-left md:justify-center items-center">
                        <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Frequency:</div>
                        <div className="whiteTitle">{handleRecurring(i.frequency.toLowerCase())}</div>
                      </div>
                      <div className="col-span-2 flex text-left md:justify-center items-center">
                        <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">On Behalf Of:</div>
                        <div className="md:text-center">{i.plaque_name}</div>
                      </div>
                      <div className="col-span-1 flex text-left md:justify-center items-center">
                        <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">QTY:</div>
                        {i.QTY}
                      </div>
                      <div className="col-span-1 price flex text-left md:justify-end items-center text-[#f60362]">
                        <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Item Amount:</div>
                        {ShowCurrencies(i.currency, i.amount)}
                      </div>
                      <div className="col-span-1 price flex text-left md:justify-end items-center text-[#f60362]">
                        <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Total Amount:</div>
                        {ShowCurrencies(i.currency, i.amount * i.QTY)}
                      </div>
                    </div>
                  );
                }
                return null;
              })}
            </div>
            <div className="grid py-2 grid-cols-12 gap-2">
              <div className="font-bold col-span-12 md:col-span-6 text-left">
                {GATEWAY === 'crypto' ? (
                  <p className="">
                    Total Donation Commitment:{' '}
                    <span className="md:hidden text-[#f60362] ml-1">{ShowCurrencies(checkoutData.currency, checkoutData.totalPrice)}</span>
                  </p>
                ) : (
                  <p className="">
                    Total Initial Donations:{' '}
                    <span className="md:hidden text-[#f60362] ml-1">{ShowCurrencies(checkoutData.currency, checkoutData.totalPrice)}</span>
                  </p>
                )}
                {GATEWAY !== 'crypto' && <p className="text-md md:text-md">Date of Issue: {Moment(checkoutData.donationDate).format('LL')}</p>}
                {MODE === 'flexible' && checkoutData.feature !== 'dhul-hijjah' && (
                  <p className="text-md md:text-md">Frequency of donation: Every Friday</p>
                )}
              </div>
              <div className="font-bold text-lg col-span-12 md:col-span-6 text-center md:text-right text-[#f60362] uppercase hidden md:flex md:justify-end">
                {ShowCurrencies(checkoutData.currency, checkoutData.totalPrice)}
              </div>
            </div>
            <div className="grid py-2 grid-cols-12 gap-2 mt-2"></div>
            {GATEWAY === 'crypto' && (
              <>
                <div className="border-x-0 border-b-2 border-black my-2 text-center hidden md:grid py-2 font-bold md:grid-cols-12 grid-gap-4">
                  <div className="col-span-3 uppercase">Transaction ID</div>
                  <div className="col-span-2 uppercase">Crypto Currency</div>
                  <div className="col-span-2 uppercase">Crypto Amount</div>
                  <div className="col-span-1 uppercase">Type</div>
                  <div className="col-span-2 uppercase">Date</div>
                  <div className="col-span-2 uppercase text-right">AMOUNT Paid</div>
                </div>
                <div className="my-3 text-center md:grid py-2 md:grid-cols-8 grid-gap-4 border-b border-stone-400 mb-5">
                  {checkoutData.cryptoTable?.map((i, index) => {
                    return (
                      <div
                        className={`w-full col-span-8 md:grid md:grid-cols-12 grid-gap-4 ${
                          index === checkoutData.cryptoTable.length - 1 ? '' : 'border-b border-stone-200'
                        }`}
                        key={`checkout${index}`}
                      >
                        <div className="col-span-3 flex text-left md:justify-center items-center">
                          <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Transaction ID:</div>
                          <div className="md:text-center overflow-hidden- flex">
                            <span className="overflow-hidden pr-4 break-all">{i.transaction_id}</span>
                            {/* {i.transaction_id.length > 30 && <span className="ml-1">...</span>} */}
                            {/* <div className="flex justify-center items-center w-6 h-6 rounded bg-slate-100 ml-1 cursor-pointer text-slate-500" onClick={()=> copyTransactionID(i.transaction_id)}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M14.3438 16.875H6.46875C5.79742 16.875 5.15359 16.6083 4.67889 16.1336C4.20418 15.6589 3.9375 15.0151 3.9375 14.3438V6.46875C3.9375 5.79742 4.20418 5.15359 4.67889 4.67889C5.15359 4.20418 5.79742 3.9375 6.46875 3.9375H14.3438C15.0151 3.9375 15.6589 4.20418 16.1336 4.67889C16.6083 5.15359 16.875 5.79742 16.875 6.46875V14.3438C16.875 15.0151 16.6083 15.6589 16.1336 16.1336C15.6589 16.6083 15.0151 16.875 14.3438 16.875Z" fill="currentColor" />
                              <path d="M5.625 2.8125H13.9177C13.7426 2.31934 13.4193 1.89242 12.9921 1.59029C12.5648 1.28816 12.0545 1.12563 11.5312 1.125H3.65625C2.98492 1.125 2.34109 1.39168 1.86639 1.86639C1.39168 2.34109 1.125 2.98492 1.125 3.65625V11.5312C1.12563 12.0545 1.28816 12.5648 1.59029 12.9921C1.89242 13.4193 2.31934 13.7426 2.8125 13.9177V5.625C2.8125 4.87908 3.10882 4.16371 3.63626 3.63626C4.16371 3.10882 4.87908 2.8125 5.625 2.8125Z" fill="currentColor" />
                            </svg>
                          </div> */}
                          </div>
                        </div>
                        <div className="col-span-2 flex text-left md:justify-center items-center">
                          <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Crypto Currency:</div>
                          <div className="whiteTitle">{i.crypto_currency}</div>
                        </div>
                        <div className="col-span-2 flex text-left md:justify-center items-center">
                          <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Crypto Amount:</div>
                          <div className="whiteTitle">
                            {i.total_crypto_amount} {i.crypto_currency}
                          </div>
                        </div>
                        <div className="col-span-1 flex text-left md:justify-center items-center">
                          <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Type:</div>
                          <div className="whiteTitle">{i.type}</div>
                        </div>
                        <div className="col-span-2 flex text-left md:justify-center items-center">
                          <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Date:</div>
                          {Moment(i.date).format('LL')}
                        </div>
                        <div className="col-span-2 price flex text-left md:justify-end items-center text-[#f60362]">
                          <div className="md:hidden text-stone-400 text-sm mr-2 min-w-[110px]">Paid Amount:</div>
                          {/* {ShowCurrencies(i.currency, i.crypto_currency_total_amount_paid)} */}
                          {ShowCurrencies(checkoutData.currency, i.crypto_currency_total_amount_paid)}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="grid py-2 grid-cols-12 gap-2">
                  <div className="font-bold col-span-12 md:col-span-6 text-left">
                    <p className="">
                      Total Paid Donations:{' '}
                      <span className="md:hidden text-[#f60362] ml-1">
                        {ShowCurrencies(checkoutData.currency, Number(checkoutData.crypto_total_paid))}
                      </span>
                    </p>
                    <p className="text-md md:text-md">Date of Issue: {Moment(checkoutData.donationDate).format('LL')}</p>
                  </div>
                  <div className="font-bold text-lg col-span-12 md:col-span-6 text-center md:text-right text-[#f60362] uppercase hidden md:flex md:flex-col md:justify-start">
                    {/* <p>{ShowCurrencies(checkoutData.currency, checkoutData.totalPrice)}</p> */}
                    <p>{ShowCurrencies(checkoutData.currency, Number(checkoutData.crypto_total_paid))}</p>
                  </div>
                </div>
              </>
            )}
            <div className="grid py-4 px-8 pr-2 pl-2 grid-cols-4 gap-4 items-center lg:items-end">
              <div className="col-span-4 md:col-span-2 lg:col-span-1 flex flex-col justify-center items-center">
                <img className="w-[50%] sm:w-[35%] md:w-[150px] mx-auto md:mx-0" src={thanksImg} alt="" />
                <span className="font-bold text-[#777] text-xl tracking-[2px]">FOR YOUR DONATIONS</span>
                {isAus && (
                  <>
                    <p className="text-[#777] text-center text-md">Donations above $2 are tax deductible in Australia*</p>
                    <p className="text-center block text-[#777] md:hidden">
                      *Excluding Build a Masjid and Dawah projects those are not eligible for tax-deductibility
                    </p>
                  </>
                )}
              </div>
              <div className="col-span-4 md:col-span-1 md:col-start-4">
                {isUk && (
                  <>
                    <p className="font-bold py-2 text-[#777] text-center md:text-left tracking-[2px]">
                      MATW <br />
                    </p>
                    <p className="text-center md:text-left text-[#777]">
                      Head office: <br />
                      Charity Number 1201110 <br />
                      275 Featherstall <br />
                      Road North <br />
                      OLDHAM OL1 2NJ <br />
                      UK
                    </p>
                  </>
                )}
                {isUsa && (
                  <>
                    <p className="font-bold py-2 text-[#777] text-center md:text-left tracking-[2px]">
                      MATW Project USA <br />
                    </p>
                    <p className="text-center md:text-left text-[#777]">
                      Head office: <br />
                      501(c)(3) organization <br />
                      2461 Eisenhower Ave. 2nd Floor <br />
                      Alexandria VA 22314 <br />
                      IRS ruling year: 2023 <br />
                      EIN: 92-1915834
                    </p>
                  </>
                )}
                {isFr && (
                  <>
                    <p className="font-bold py-2 text-[#777] text-center md:text-left tracking-[2px]">
                      MATW INTERNATIONAL FRANCE <br />
                    </p>
                    <p className="text-center md:text-left text-[#777]">
                      Legal address is: <br />
                      43 Rue de liege 75008 Paris <br />
                      SIREN: 938213410
                      <br />
                      SIRET: 93821341000013
                    </p>
                  </>
                )}
                {!isUk && !isUsa && !isFr && (
                  <>
                    <p className="font-bold py-2 text-[#777] text-center md:text-left tracking-[2px]">
                      MATW INTERNATIONAL LTD <br />
                      ABN: 60 610 666 325
                    </p>
                    <p className="text-center md:text-left text-[#777]">
                      Head office: <br />
                      Australia HQ <br />
                      L2, 47 Rickard Rd <br />
                      Bankstown 2200 <br />
                      Australia
                    </p>
                  </>
                )}
              </div>
              <div className="col-span-4 mt-2">
                <p className="col-span-5 text-stone-500 mb-4 text-center">
                  Check out our most recent
                  {/* <Link to={`../pdf/Ramadan Impact Report - Week 3_compressed.pdf`} target="_blank" className="text-blue-500 ml-1"> */}
                  {/* <Link to={`../pdf/MATW_General_2024_Achievements_Report_V7.pdf`} target="_blank" className="text-blue-500 ml-1"> */}
                  <Link
                    to={`../pdf/Ramadan_2025_Impact_Report_(Week_3.5,_1st_March_2025_to_25th_March_2025)_D1_compressed.pdf`}
                    target="_blank"
                    className="text-blue-500 ml-1"
                  >
                    project impact report.
                  </Link>
                </p>
                <p className="col-span-5 text-stone-500 mb-4 text-center">
                  {/* To check or cancel any subscriptions please visit <a href="https://matwproject.org/cancel" className='text-blue-500'>matwproject.org/cancel</a>. */}
                  To check or cancel any subscriptions{' '}
                  <a href={`${window.location.protocol}//${window.location.host}/cancel`} className="text-blue-500">
                    please visit this page
                  </a>
                  .
                </p>
                <p className="text-center hidden md:block text-[#777]">
                  *Excluding Build a Masjid and Dawah projects those are not eligible for tax-deductibility
                </p>
              </div>
              <div className="col-span-4 mt-4">
                <div className="mb-6">
                  <p className="w-full text-[#00a3da] leading-[20px] text-center text-md mb-3">
                    Download the new MATW Project app <br /> and make giving easier
                  </p>
                  <div className="flex justify-center items-center gap-6">
                    <div className="flex flex-col items-center justify-center gap-3">
                      <Link to="https://play.google.com/store/apps/details?id=com.matwproject.matw">
                        <img src={androidAppLogo} alt="MATW Google App" className="w-32" />
                      </Link>
                      <img src={androidAppQr} alt="MATW Google App QR" className="w-32 hidden sm:block" />
                    </div>
                    <div className="flex flex-col items-center justify-center gap-3">
                      <Link to="https://apps.apple.com/pk/app/matw-project-pay-zakat/id6446399296">
                        <img src={iosAppLogo} alt="MATW IOS App" className="w-32" />
                      </Link>
                      <img src={appleAppQr} alt="MATW Google App QR" className="w-32 hidden sm:block" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="">
            {/* <img src={checkDomain('matwproject.org') ? footerImg : footerQurbaniImg} alt="MATW" className="w-full" /> */}
            <img src={footerImg} alt="MATW" className="w-full" />
          </div>
        </>
      )}
    </div>
  ) : (
    <div role="status" className="w-full flex justify-center items-center min-h-[500px]">
      <svg
        aria-hidden="true"
        className="w-20 h-20 mr-2 text-gray-200 animate-spin fill-[#00a3da]"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default ReceiptPage;
